import { BaseFetch } from "../main-model"
export default class TrainingModel extends BaseFetch {
  getTypeOfAdmissionBy = (data) =>
    this.authFetch({
      url: "type-of-admission/getTypeOfAdmissionBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getTypeOfAdmissionById = (data) =>
    this.authFetch({
      url: "type-of-admission/getTypeOfAdmissionById",
      method: "POST",
      body: JSON.stringify(data),
    })
  insertTypeOfAdmission = (data) =>
    this.authFetch({
      url: "type-of-admission/insertTypeOfAdmission",
      method: "POST",
      body: JSON.stringify(data),
    })
  updateTypeOfAdmissionById = (data) =>
    this.authFetch({
      url: "type-of-admission/updateTypeOfAdmissionById",
      method: "POST",
      body: JSON.stringify(data),
    })
  deleteTypeOfAdmissionById = (data) =>
    this.authFetch({
      url: "type-of-admission/deleteTypeOfAdmissionById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
